import GetOrganisationsRequestModelBase from '../_generated/modelBases/get-organisations-request-model-base';

export default class GetOrganisationsRequestModel extends GetOrganisationsRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
